import { useEffect, useState } from 'react'

/**
 * Tracks which entrance animations have already run in this page load.
 * Module scope rather than component state: the point is to survive unmounts.
 */
const played = new Set<string>()

/**
 * Entrance animations should play once per page load, not once per mount.
 *
 * Boot mounts LoadingShell twice in sequence — once from the route guard while
 * auth resolves, then again from ApplicationSuiteProvider while usermeta and
 * product tags load. Replaying the fade on the second mount blanks the loader
 * for the animation's delay and then fades it back in, which reads as the
 * loader failing rather than as a transition.
 *
 * Returns true only on the first mount of `key` in this page load.
 */
export default function useIntroAnimation(key: string): boolean {
  const [shouldPlay] = useState(() => !played.has(key))

  useEffect(() => {
    played.add(key)
  }, [key])

  return shouldPlay
}
